export function salaryMonths(rows,year){
 return Array.from({length:12},(_,i)=>{
  const month=`${year}-${String(i+1).padStart(2,'0')}`;
  const selected=rows.filter(r=>r.payroll_kind==='SUELDOS'&&r.month===month);
  const sum=k=>!selected.length||selected.some(r=>r[k]==null)?null:selected.reduce((n,r)=>n+Number(r[k]),0);
  return {month,paid:selected.length>0&&selected.every(r=>r.paid===true),base:sum('base_amount'),hours:sum('base_hours'),operations:sum('operations_amount'),count:sum('operation_count')};
 });
}
export const average=(months,key)=>{const values=months.filter(m=>m[key]!=null);return values.length?values.reduce((n,m)=>n+m[key],0)/values.length:null;};
